// src/components/SlideShow.js
import React, { useEffect, useState } from "react";
import "../style/slideshow.css";
import aboutSection3image from "../assets/aboutSection3image.jpg";
import sideview from "../assets/sideview.jpg";
import frontview from "../assets/frontview.jpg";
import garden from "../assets/garden.jpg";

const SlideShow = () => {
  const images = [aboutSection3image, sideview, frontview, garden];

  const [currentSlide, setCurrentSlide] = useState(0);

  // Auto-slide every 5 seconds
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % images.length);
    }, 2000);
    return () => clearInterval(timer);
  }, [images.length]);

  const goToPrevious = () => {
    setCurrentSlide((prev) => (prev - 1 + images.length) % images.length);
  };

  const goToNext = () => {
    setCurrentSlide((prev) => (prev + 1) % images.length);
  };

  return (
    <div className="slideshow-container">
      <div className="slide-wrapper">
        {images.map((image, index) => (
          <img
            key={index}
            src={image}
            loading="lazy"
            alt={`Slide ${index + 1}`}
            className={`slide-image ${
              index === currentSlide ? "opacity-100" : "opacity-0"
            }`}
            onError={() => console.error(`Failed to load image ${index + 1}`)} // Debug image loading
          />
        ))}
      </div>
      <button onClick={goToPrevious} className="nav-button prev-button">
        ←
      </button>
      <button onClick={goToNext} className="nav-button next-button">
        →
      </button>
      <div className="dots-container">
        {images.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`dot ${index === currentSlide ? "active" : ""}`}
          ></button>
        ))}
      </div>
    </div>
  );
};

export default SlideShow;
